__turbopack_context__.v({
  "badge": "ConnectionsSdkCredentialsNav-module__8CqNHa__badge",
  "label": "ConnectionsSdkCredentialsNav-module__8CqNHa__label",
  "nav": "ConnectionsSdkCredentialsNav-module__8CqNHa__nav",
});
